<!--

FORMULARIO PARA ESCOLHER A APLICACAO E EFETUAR A ATIVACAO DA CONTA

-->


<template>
    <div class="registro">
        <header class="shared-header">
                    <div class="col-md-12 col-12 text-center">
                        <a class="valign" href="#">
                            <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo-nb.png">
                        </a>
                    </div>
        </header>
        <!-- <transition name="fade">
            <div class="container" v-if="estagio == 'aplicativos'" style="margin-bottom: 100px">
                <div class="row activation justify-content-center">
                    <h2 class="title-principal">Informe-nos quais aplicativos você tem interesse</h2>
                </div>
                <div class="activation">
                    <div class="row justify-content-center text-center" v-for="(app, index) in aplicativos" :key="index">
                        <div class="app" :class="{'active': app.selected}" @click="app.selected = !app.selected">
                            <div class="title"> {{ app.title }} </div>
                            <p> {{ app.descricao }} </p>
                        </div>                            
                    </div>
                </div>
                <div class="row justify-content-center">
                    <small v-if="selecionados.length>0" class="float-left"> Selecionados: {{ selecionados.length }} </small>
                    <small v-if="selecionados.length==0" class="error"> {{ errmessages }} </small>
                </div>
                <div class="row justify-content-center nb-margin-bottom" style="padding-top: 30px">
                    <button type="button" class="activation-button" @click="handleEfetuarAtivacao()">Efetuar Ativação</button>
                </div>
                <div class="row justify-content-center">
                    <a href="javascript:void(0);" @click="estagio='registro'">Retornar</a>
                </div>
            </div>
        </transition> -->

        <transition name="fade">
            <div class="activation text-center" v-if="ativando">
                <h2 class="title-principal">Efetuando ativação...</h2>
            </div>
            <div class="activation text-center">
                <h2 class="title-principal" v-if="sucesso">Sucesso!</h2>
                <h3>Sua conta foi ativada. Você será redirecionado à tela de login.</h3>
                <button type="button" class="activation-button" @click="handleLogin()">Ok</button>
            </div>
        </transition>

    </div>
</template>

<script>

import { apiORDSapp } from '../shared/api-functions'

export default {
    props: {
    },

    data() {
        return {
            errmessages: null,  //armazena as mensagens de validacao do servidor para mostrar em tela
            // estagio: '',

            ativando: true,
            sucesso: false,

            uuid: '',

            // aplicativos: [
            //     { title: "Controle de Pedidos", descricao: "Receba pedidos lançados pelos seus representantes", selected: false },
            //     { title: "Emissor de Notas Fiscais", descricao: "Controle de pedidos de venda, emissão de notas fiscais de produtos e boletos", selected: false },
            //     { title: "Emissor de Notas de Importação", descricao: "Emita notas fiscais de importação em 1 minuto", selected: false },
            //     { title: "Frente de Caixa / Varejo", descricao: "Aplicativo de frente de caixa com controle de estoque e controle financeiro", selected: false },
            // ],

        }
    },

    computed: {
        selecionados: function () {
            return this.aplicativos.filter((obj) => {
               return obj.selected
            })
        }
    },

    methods: {
        handleEfetuarAtivacao() {
            let selecionou = false
            for (var x = 0; x < this.aplicativos.length; x++){
                if (this.aplicativos[x].selected) {
                    selecionou = true
                }
            }
            if (!selecionou) {
                this.errmessages = 'Selecione um aplicativo para prosseguir'
            } else {
                this.estagio = 'ativando'
            }
        },

        async apiPost () {
            this.sucesso = false
            this.ativando = true
            var params = '?uuid=' + this.uuid
            var data = { aplicativos: this.aplicativos }
            const ativacao = await apiORDSapp(this, 'assinatura/ativar' + params, 'post', data)
            this.$appLoading(false)
            if (ativacao.errmessages) {
              this.ativando = false
              this.errmessages = login.errmessages
              return
            } else {
              this.ativando = false
              this.sucesso = true
            }
        },

        handleLogin () {
            this.$router.push('/login')
        }
    },

    components: {
    },

    beforeCreate () {
    },

    mounted () {
    },

    created () {
        if (this.$route.query && this.$route.query.uuid) {
            this.uuid = this.$route.query.uuid
        } else {
            this.$router.push('/login')
        }
        
        this.$scrollTo(0)
        this.apiPost()
        
    }

}

</script>

<style>

.shared-header {
    display: block;
    padding: 15px 0;
    margin-top: 15px;
}

.shared-header .valign {
    line-height: 30px;
    vertical-align: middle;
}

.activation {
    margin-top: 64px;
}

.activation h3 {
    margin-bottom: 32px;
    font-size: 30.4px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.58;
    letter-spacing: -.5px;
    color: #222;
    margin-top: 64px;
}

.activation-button {
    border: 2px solid #267da5!important;
    /* border-radius: 3px!important; */
    border-radius: 0.70rem;
    margin-top: 50px;
    cursor: pointer;
    width: 200px!important;
    height: 45px!important;
    background-color: #267da5!important;
    color: #fff!important;
    font-size: 15px!important;
}


.title-principal {
    color: #222;
    font-size: 36px;
    font-weight: 800;
    letter-spacing: -1.13px;
    line-height: 44px;
    margin: 25px 0 0;
}

.registro {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  /* display: table; */
  display: block;
  transition: opacity .3s ease;
  overflow: auto;
}

.login-button {
    border: 2px solid #267da5!important;
    border-radius: 0.70rem;
    cursor: pointer;
    height: 45px!important;
    background-color: #267da5!important;
    color: #fff!important;
    font-size: 15px!important;
}

.app {
    /* width: 270px; */
    width: 50%;
    /* height: 280px; */
    /* height: 280px; */
    margin: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 2px solid #E0E0E0;
    border-radius: 15px;
    padding: 15px;
    cursor: pointer;
    font-size: 22px;
    letter-spacing: -0.15px;
    line-height: 24px;
    transition: all .2s;
}

.app:hover {
    border: 3px solid #00CC62;
}

.active {
    border: 3px solid #00CC62;
}

.app .title {
    color: #222;
    margin-bottom: 32px;
    font-size: 22px;
    letter-spacing: -0.15px;
    line-height: 27px;
    display: flex;
    align-items: flex-end;
    flex: 1;
    transition: all .2s;
}

.app p {
    color: #757575;
    font-family: Open Sans, sans-serif;
    letter-spacing: -0.5px;
    font-size: 14px;
    line-height: 19px;
    flex: 1;
    transition: all .2s;
}

</style>



// WEBPACK FOOTER //
// src/forms/app-ativacao-form.vue